import React from "react";
import { connect } from "react-redux";
import {injectIntl} from "react-intl";
import PropTypes from "prop-types";

import TextField from "@mui/material/TextField";
import {changeUserInfo, changeUserInfoErrors} from "../../../actions/actionFunctions";
import {onInputBlur, onInputChange, useInputsValidation} from "../ui/inputFunctions";

export const getValidationErrors = (property, currentValue) => {
  const errors = [];

  switch (property) {
    case "firstName": {
      if (!currentValue) {
        errors.push("look.inputs.errors.fieldRequired");
        return errors
      }
      if (currentValue.length === 1) {
        errors.push("look.inputs.errors.shortName");
      } else if (currentValue.length > 50) {
        errors.push("look.inputs.errors.longName");
      }
      if (!/^[A-Z\s\'\-\&\.a-z]+$/.test(currentValue)) {
        errors.push("look.inputs.errors.nameIsIncorrect");
      }
      break;
    }
    case "email": {
      if (!currentValue) {
        errors.push("look.inputs.errors.fieldRequired");
        return errors
      }
      if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(currentValue)) {
        errors.push("look.inputs.errors.invalidEmail");
      }
      break;
    }
    case "password": {
      if (!currentValue) {
        errors.push("look.inputs.errors.fieldRequired");
        return errors
      }
      break;
    }
    case "postal": {
      if (!currentValue) {
        errors.push("look.inputs.errors.fieldRequired");
        return errors
      }
      const regex = /[a-zA-Z0-9][a-zA-Z0-9\- ]{0,10}[a-zA-Z0-9]/;
      if (!regex.test(currentValue)) {
        errors.push("look.inputs.errors.incorrectPostal");
        return errors
      }
      break;
    }
  }
  return errors
}

const LookUserInput = (props) => {

  const {property, userInfo, changeUserInfo, intl, userInfoErrors, changeUserInfoErrors, inputsValidated, shrink,
    fabricatorData, className, tabIndex} = props;
  // const [inputValue, setInputValue] = useState(userInfo[property] || "");

  const userInputChange = (property, value) => {
    changeUserInfo({
      [property]: value
    });
  }

  const userInputBlur = (property, value) => {
    if (userInfo[property] !== value) {
      changeUserInfo({
        [property]: value
      });
    }
  }

  const onBlur = (event) => {
    onInputBlur(event, property, userInputBlur, userInfoErrors, changeUserInfoErrors, getValidationErrors);
  };

  useInputsValidation(inputsValidated, onBlur, userInfo[property]);

  const onChange = (event) => {
    onInputChange(event, property, userInputChange, userInfoErrors, changeUserInfoErrors, getValidationErrors);
  };

  const errorsExist = Array.isArray(userInfoErrors[property]) && !!userInfoErrors[property].length;

  const requiredFields = ["firstName", "email", "postal", "phoneNumber"];
  const type = property !== "email" && property !== "password" ? "text" : property;
  const label = property === "postal" && fabricatorData.isRenuit
    ? "Postal Code"
    : intl.formatMessage({id: "look.inputs." + property})

  return (
    <div className={"look-block" + (className ? " " + className : "")}>
      <TextField className="look-input"
                 type={type}
                 value={userInfo[property]}
                 required={requiredFields.includes(property)}
                 size="small"
                 label={label}
                 onChange={onChange}
                 onBlur={onBlur}
                 error={errorsExist}
                 InputLabelProps={{shrink}}
                 inputProps={{tabIndex}}
                 name={property}
                 helperText={
                   errorsExist ? intl.formatMessage({id : userInfoErrors[property][0]}): ""
                 }
                 variant="outlined" />
    </div>
  )
};

LookUserInput.propTypes = {
  property: PropTypes.string.isRequired,
  inputsValidated: PropTypes.bool.isRequired,
  shrink: PropTypes.bool,
  className: PropTypes.string,
  tabIndex: PropTypes.number,
};

const mapStateToProps = (store) => {
  const {userInfo, userInfoErrors} = store.userState;
  const fabricatorData = store.fabricatorState;
  return {
    userInfo,
    userInfoErrors,
    fabricatorData,
  };
};

const mapDispatchToProps = {
  changeUserInfo,
  changeUserInfoErrors
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LookUserInput)
)
